import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Stack, Typography } from "@mui/material";
import { useTheme, lighten, darken } from "@mui/material/styles";
import { FieldControl, SelectField, } from "@pangeacyber/react-mui-shared";
import { useState } from "react";
import { ObjectStore } from "../../../types";
import { useStoreFileViewerContext } from "../../../hooks/context";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
var ShareLinkAccess = function (_a) {
    var labels = _a.labels, value = _a.value;
    var theme = useTheme();
    var modify = theme.palette.mode === "dark" ? darken : lighten;
    return (_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsxs(IconButton, { sx: { bgcolor: modify(theme.palette.info.main, 0.9) }, children: [value === "download" && _jsx(DownloadIcon, { fontSize: "small" }), value === "upload" && _jsx(UploadIcon, { fontSize: "small" }), value === "editor" && _jsx(BorderColorIcon, { fontSize: "small" })] }), _jsxs(Stack, { children: [_jsxs(Stack, { direction: "row", alignItems: "center", children: [_jsx(Typography, { variant: "body2", children: labels.join(", ") }), _jsx(ArrowDropDownIcon, { fontSize: "small" })] }), value === "download" && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: "People with this link can download files" })), value === "upload" && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: "People with this link can upload files to the shared folder" })), value === "editor" && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: "People with this link can download/upload and edit all files within the folder" }))] })] }));
};
var UnControlledShareLinkTypeField = function (_a) {
    var props = __rest(_a, []);
    var configurations = useStoreFileViewerContext().configurations;
    var theme = useTheme();
    var _b = useState(ObjectStore.ShareAuthenticatorType.Sms), authenticatorType = _b[0], setAuthenticatorType = _b[1];
    return (_jsx(Stack, { spacing: 0.5, children: _jsx(SelectField, __assign({}, props, { label: "", FieldProps: __assign(__assign({}, props === null || props === void 0 ? void 0 : props.FieldProps), { CustomValueEl: ShareLinkAccess, SelectFieldProps: {
                    fullWidth: false,
                } }), variant: "standard", sx: {
                ".MuiSelect-icon": {
                    visibility: "hidden",
                },
                ".MuiSelect-select.MuiSelect-standard:focus": {
                    bgcolor: "inherit",
                },
            } })) }));
};
var ShareLinkTypeField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledShareLinkTypeField, __assign({}, props)) })));
};
export default ShareLinkTypeField;
